module.exports = __webpack_public_path__ + "static/pandas-4d122aeef969637aeaee0e1cb996b610.svg";